/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import bgModal from 'static/bg-modal.png'
import { getGameAsset } from 'helpers/gameAssets';

const Modal = ({ onClose, onCloseOutside, open, children, gameCode, backgroundImage }) => {
  const _formRef = useRef();
  const [height, setHeight] = useState(0);

  useEffect(() => {
    document.body.style.overflowY = open ? 'hidden' : 'auto';
  }, [open]);

  useEffect(() => {
    if (
      _formRef?.current &&
      height !== _formRef?.current?.getBoundingClientRect().height
    )
      setHeight(_formRef?.current?.getBoundingClientRect().height);
  }, [children]);

  return (
    <div
      role="presentation"
      className={classNames(
        'fixed z-40 right-0 left-0 w-screen bottom-0 bg-[#00000073] bg-modal',
        {
          'h-screen': open,
          'h-0': !open
        }
      )}
      onClick={onCloseOutside}
    >
      <div
        role="presentation"
        className={classNames(
          'mx-5 modal-open fixed z-50 right-0 left-0 bottom-0 rounded-t-[24px] overflow-hidden transition-[height] duration-300'
        )}
        style={{
          backgroundImage: backgroundImage ??  `url(${getGameAsset(gameCode, 'bg-modal', bgModal)})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          // maxHeight: 'calc(100vh - 2rem)',
          height: open ? 'calc(100vh - 2rem)' : '0'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div ref={_formRef} className="relative h-100" style={{ height: open ? 'calc(100vh - 2rem)' : '0' }}>
          {children}
        </div>
      </div>
    </div>
  );
};

Modal.defaultProps = {
  onClose: () => { },
  open: false
};

export default Modal;
